<div class="quicksight-container">
<!--  <div class="qs-details-header">-->
<!--    <div class="qs-details-header__title">-->
<!--      <h2>Dashboard</h2>-->
<!--    </div>-->
<!--  </div>-->

  <div class="dashboard-content">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>
      <p>Loading QuickSight dashboard...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <div class="error-icon">
        <i
          class="pi pi-exclamation-triangle"
          style="font-size: 3rem; color: #e74c3c"
        ></i>
      </div>
      <h3>Failed to Load Dashboard</h3>
      <p>{{ errorMessage }}</p>
    </div>

    <!-- Dashboard Container - Always present but hidden when loading/error -->
    <div
      #dashboardContainer
      class="iframe-container"
      [style.display]="!isLoading && !errorMessage ? 'block' : 'none'"
    ></div>
  </div>
</div>

